import React from "react";

import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {getParkingPlacesType} from "../constants/ParkingPlacesType";
import {OfferGeneratedDescriptionTextCommercials} from "./OfferGeneratedDescriptionTextCommercials";

interface IProps {
    className?: string;
    offer: {
        buildings: number;
        construction_date_range: IRangeQuery<string>;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        investor: string | null;
        name: string;
        parking_places: IParkingPlace[];
        properties: number;
        stats: {
            properties_count_for_sale: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
        } | null;
        storage: {
            quantity: number;
            description: string;
            price: number;
        };
        vendor: {
            type: VendorType;
            name: string;
        };
    };
}

export const OfferDetailGeneratedDescriptionCommercial = (props: IProps) => {
    const {offer} = props;

    const renderParkingPlaces = () =>
        offer.parking_places.map((parkingPlace: IParkingPlace) => {
            return <li key={parkingPlace.id}>{getParkingPlacesType(parkingPlace.type).toLowerCase()} </li>;
        });

    const offerInvestorOrVendor = offer.vendor.type === VendorType.DEVELOPER ? offer.investor || offer.vendor.name : "deweloper";

    return (
        <>
            <OfferGeneratedDescriptionTextCommercials offer={offer} />

            {offer.parking_places?.length > 0 ? (
                <>
                    <p>Dla przyszłych właścicieli {offerInvestorOrVendor} przewidział:</p>

                    <ul>{renderParkingPlaces()}</ul>
                </>
            ) : (
                <p>Dla przyszłych właścicieli {offerInvestorOrVendor} nie przewidział miejsc postojowych.</p>
            )}
        </>
    );
};
import React from "react";

import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {getParkingPlacesType} from "../constants/ParkingPlacesType";
import {OfferGeneratedDescriptionTextCommercials} from "./OfferGeneratedDescriptionTextCommercials";

interface IProps {
    className?: string;
    offer: {
        buildings: number;
        construction_date_range: IRangeQuery<string>;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        investor: string | null;
        name: string;
        parking_places: IParkingPlace[];
        properties: number;
        stats: {
            properties_count_for_sale: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
        } | null;
        storage: {
            quantity: number;
            description: string;
            price: number;
        };
        vendor: {
            type: VendorType;
            name: string;
        };
    };
}

export const OfferDetailGeneratedDescriptionCommercial = (props: IProps) => {
    const {offer} = props;

    const renderParkingPlaces = () =>
        offer.parking_places.map((parkingPlace: IParkingPlace) => {
            return <li key={parkingPlace.id}>{getParkingPlacesType(parkingPlace.type).toLowerCase()} </li>;
        });

    const offerInvestorOrVendor = offer.vendor.type === VendorType.DEVELOPER ? offer.investor || offer.vendor.name : "deweloper";

    return (
        <>
            <OfferGeneratedDescriptionTextCommercials offer={offer} />

            {offer.parking_places?.length > 0 ? (
                <>
                    <p>Dla przyszłych właścicieli {offerInvestorOrVendor} przewidział:</p>

                    <ul>{renderParkingPlaces()}</ul>
                </>
            ) : (
                <p>Dla przyszłych właścicieli {offerInvestorOrVendor} nie przewidział miejsc postojowych.</p>
            )}
        </>
    );
};
